import { lazy } from "react";

const AdminAreaWmsPage = lazy(() => import("./pages/admin-area"));
const DeviceWmsPage = lazy(() => import("./pages/device/wms"));
const DeviceWcsPage = lazy(() => import("./pages/device/wcs"));
const DeviceScannerPage = lazy(() => import("./pages/device/scanner"));
const DeviceScreenPage = lazy(() => import("./pages/device/screen"));
const DeviceAlertPage = lazy(() => import("./pages/device/alert"));
const P2lInboundPage = lazy(() => import("./pages/p2l/inbound"));

const WheelConfigPage = lazy(() => import("./pages/wheel/plan-config"));
const WheelStatistic = lazy(() => import("./pages/wheel/statistic"));
const WheelChute = lazy(() => import("./pages/wheel/chute"));
const WheelInduction = lazy(() => import("./pages/wheel/induction"));
const WheelOperationConfig = lazy(
  () => import("./pages/wheel/operation-config")
);
const WheelPlan = lazy(() => import("./pages/wheel/plan"));

const CrossbeltConfigPage = lazy(() => import("./pages/crossbelt/plan-config"));
const CrossbeltStatistic = lazy(() => import("./pages/crossbelt/statistic"));
const CrossbeltChute = lazy(() => import("./pages/crossbelt/chute"));
const CrossbeltInduction = lazy(() => import("./pages/crossbelt/induction"));
const CrossbeltCarrier = lazy(() => import("./pages/crossbelt/carrier"));
const CrossbeltOperationConfig = lazy(
  () => import("./pages/crossbelt/operation-config")
);
const CrossbeltPlan = lazy(() => import("./pages/crossbelt/plan"));
const DeviceSortingPage = lazy(() => import("./pages/device-sorting"));
const StatisticQuantityPage = lazy(() => import("./pages/statistic/quantity"));
const StatisticImExportPage = lazy(() => import("./pages/statistic/imexport"));

export const WmsRoutes = [

  { path: "admin-area", element: <AdminAreaWmsPage /> },
  { path: "device/wms", element: <DeviceWmsPage /> },

  { path: "device/wcs", element: <DeviceWcsPage /> },
  { path: "device/scanner", element: <DeviceScannerPage /> },
  { path: "device/screen", element: <DeviceScreenPage /> },
  { path: "device/alert", element: <DeviceAlertPage /> },

  { path: "p2l/inbound", element: <P2lInboundPage /> },
  { path: "wheel/chute", element: <WheelChute /> },
  { path: "wheel/induction", element: <WheelInduction /> },
  { path: "wheel/plan/:planId", element: <WheelConfigPage /> },
  { path: "wheel/plan", element: <WheelPlan /> },
  { path: "wheel/statistic", element: <WheelStatistic /> },
  { path: "wheel/operation-config", element: <WheelOperationConfig /> },

  { path: "crossbelt/chute", element: <CrossbeltChute /> },
  { path: "crossbelt/induction", element: <CrossbeltInduction /> },
  { path: "crossbelt/plan/:planId", element: <CrossbeltConfigPage /> },
  { path: "crossbelt/plan", element: <CrossbeltPlan /> },
  { path: "crossbelt/statistic", element: <CrossbeltStatistic /> },
  { path: "crossbelt/carrier", element: <CrossbeltCarrier /> },
  { path: "crossbelt/operation-config", element: <CrossbeltOperationConfig /> },

  { path: "device-sorting", element: <DeviceSortingPage /> },
  { path: "statistic/quantity", element: <StatisticQuantityPage /> },
  { path: "statistic/imexport", element: <StatisticImExportPage /> }
];
export default WmsRoutes;
